import { Hosting } from 'src/core/ahp';
import { t_ahp_configuration } from 'src/core/configuration';

export interface IModuleConfiguration {
  disabled: boolean;
}

export class ModuleConfiguration {
  constructor(public ahp: Hosting) {}

  uninitialize(configuration: IModuleConfiguration) {}
  initialize(configuration: IModuleConfiguration, allConfiguration: unknown): Promise<unknown> {
    return Promise.resolve();
  }

  activate(configuration: Partial<Record<t_ahp_configuration, IModuleConfiguration>>): Promise<unknown> {
    return Promise.resolve();
  }
}
